<template>
  <Day day="13.12.2025">
    <div slot="page-content">
      <h3>Surf + Fun 🏄🏻‍♀️</h3>
      <p>
        <img src="@/assets/day13.jpeg"/>
      </p>
    </div>
  </Day>
</template>

<script>
import Day from '../Day.vue'

export default {
  name: 'Day13',
  components: {
    Day
  }
}
</script>
